var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"s-skeleton-form"},[_c('div',{staticClass:"s-skeleton-form__header"},[_c('h1',{staticClass:"app-private-title-dark text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"s-skeleton-form__body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }